import axios from "axios";
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { logOutRedirectCall, showErrorMessage } from "../pages/common/Utils";

let key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_KEY);
let iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_IV);

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
  headers: {
    'api-key': process.env.REACT_APP_API_KEY,
    'Accept-Language': 'en',
    'Content-Type': 'text/plain',
  }
});

// Body Encryption Request. The session itself now travels via an httpOnly cookie the
// browser attaches automatically (withCredentials above) — no token header to inject here.
// The CSRF token lives in a non-httpOnly cookie specifically so it CAN be read here and
// echoed back as a header, per the double-submit CSRF pattern the backend validates.
axiosClient.interceptors.request.use(function (request) {
  request.data = bodyEncryption(request.data, true);
  const csrfToken = Cookies.get('csrf_token');
  if (csrfToken) {
    request.headers['x-csrf-token'] = csrfToken;
  }
  return request;
});

axiosClient.interceptors.response.use(
  function (response) {
    response = bodyDecryption(response.data);

    let respData = JSON.parse(response);
    if (parseInt(respData.code) === -1) {
      logOutRedirectCall();
      return;
    }
    if (parseInt(response.code) === 0) {
      console.log(response.data.message);
    }
    response = JSON.parse(response)
    return response;
  },
  function (error) {
    let res = error.response;
    // getProfile's 401 is not an error — it's how AuthContext normally discovers "not logged
    // in", and it already handles that gracefully on its own. Forcing a redirect here too
    // would fire on the login page itself (which also mounts AuthContext) and reload-loop.
    const isProfileCheck = error.config && error.config.url && error.config.url.endsWith('getprofile');
    if (error.code && error.code === 'ERR_NETWORK') {
      logOutRedirectCall()
      showErrorMessage(`${error.code}: ${error.message}`);
    }
    if (res && res.status && parseInt(res.status) === 401 && !isProfileCheck) {
      logOutRedirectCall()
    }
    return Promise.reject(error);
  }
);

function bodyEncryption(request, isStringify) {

  request = (isStringify) ? JSON.stringify(request) : request;
  let encrypted = CryptoJS.AES.encrypt(request, key, { iv: iv });
  return encrypted.toString();
}

function bodyDecryption(request) {
  let decrypted = CryptoJS.AES.decrypt(request.toString(), key, { iv: iv });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export { axiosClient };
